import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, Linkedin, Facebook, Instagram } from 'lucide-react';
import { companyInfo } from '../mockData';

const logoSrc = `${process.env.PUBLIC_URL || ''}/logo-white.png`;

export const FooterAlt = () => {
  const navigationLinks = [
    { label: 'Início', path: '/' },
    { label: 'Catálogos', path: '/catalogos' },
    { label: 'Sobre', path: '/sobre' },
    { label: 'Contactos', path: '/contactos' }
  ];

  return (
    <footer className="bg-[#262d37] text-white pt-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16">
          {/* Brand */}
          <div className="lg:col-span-4">
            <img
              src={logoSrc}
              alt={companyInfo.name}
              className="h-12 w-auto object-contain mb-8"
            />
            <p className="text-white text-base leading-relaxed">
              Trazemos luz ao seu projeto, transformando a iluminação do seu espaço.
            </p>
            <p className="text-white/80 text-sm leading-relaxed mt-4">
              {companyInfo.address}
            </p>
            <div className="flex gap-4 pt-6">
              <a href="#" className="w-10 h-10 border border-white/20 rounded-full flex items-center justify-center hover:border-white hover:bg-white hover:text-black transition-all">
                <Linkedin size={18} />
              </a>
              <a href="#" className="w-10 h-10 border border-white/20 rounded-full flex items-center justify-center hover:border-white hover:bg-white hover:text-black transition-all">
                <Facebook size={18} />
              </a>
              <a href="#" className="w-10 h-10 border border-white/20 rounded-full flex items-center justify-center hover:border-white hover:bg-white hover:text-black transition-all">
                <Instagram size={18} />
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div className="lg:col-span-2">
            <h3 className="text-sm font-semibold mb-6 text-white uppercase tracking-wider">Navegação</h3>
            <ul className="space-y-4 text-white">
              {navigationLinks.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-base hover:text-neutral-400 transition-colors inline-flex items-center gap-2 group"
                  >
                    {item.label}
                    <ArrowUpRight size={16} className="opacity-0 group-hover:opacity-100 transition-opacity" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div className="lg:col-span-3">
            <h3 className="text-sm font-semibold mb-6 text-white uppercase tracking-wider">Serviços</h3>
            <ul className="space-y-4 text-white">
              <li>Consultoria e Design</li>
              <li>Fornecimento de Material</li>
              <li>Gestão de Projeto</li>
              <li>Eficiência Energética</li>
            </ul>
          </div>

          {/* Contact */}
          <div className="lg:col-span-3">
            <h3 className="text-sm font-semibold mb-6 text-white uppercase tracking-wider">Contacto</h3>
            <div className="space-y-4">
              <a href={`mailto:${companyInfo.email}`} className="block text-base hover:text-white/70 transition-colors">
                {companyInfo.email}
              </a>
              <a href={`mailto:${companyInfo.projectsEmail}`} className="block text-base hover:text-white/70 transition-colors">
                {companyInfo.projectsEmail}
              </a>
              <div className="space-y-1">
                <a href={`tel:${companyInfo.phone.replace(/\s/g, '')}`} className="text-white hover:text-white/70 transition-colors">
                  {companyInfo.phone}
                </a>
              </div>
              <div className="text-sm text-white/80 space-y-1 pt-2">
                <p className="font-semibold text-white">Horário de Atendimento</p>
                <p>Segunda - Sexta: 09:00 - 18:00</p>
                <p>Sábado e Domingo: Fechado</p>
              </div>
            </div>
          </div>
        </div>


      </div>
      {/* Bottom Bar */}
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
        <p className="text-white text-sm">
          © {new Date().getFullYear()} LuxDall. Todos os direitos reservados.
        </p>
        <nav
          aria-label="Legal e reclamações"
          className="flex flex-col items-center sm:flex-row sm:flex-wrap sm:justify-center md:justify-end gap-y-1 sm:gap-x-2 sm:gap-y-0 text-neutral-500 text-sm w-full sm:w-auto"
        >
          <div className="flex flex-row flex-wrap justify-center items-center gap-x-2">
            <Link
              to="/privacidade"
              className="transition-colors py-1 sm:py-0 text-center text-white hover:text-white/70"
            >
              Política de Privacidade
            </Link>
            <span className="text-white select-none" aria-hidden="true">/</span>
            <Link
              to="/termos"
              className="transition-colors py-1 sm:py-0 text-center text-white hover:text-white/70"
            >
              Termos de Serviço
            </Link>
          </div>
          <span className="hidden sm:inline text-white select-none" aria-hidden="true">/</span>
          <a
            href="https://www.livroreclamacoes.pt/INICIO/"
            target="_blank"
            rel="noopener noreferrer"
            className="transition-colors py-1 sm:py-0 text-center text-white hover:text-white/70"
          >
            Livro de Reclamações
          </a>
        </nav>
      </div>
    </footer>
  );
};
